import React from "react";
import { Lightbulb, Wrench, Layers, Hammer } from "lucide-react";

const steps = [
  {
    icon: Lightbulb,
    title: "Understand",
    desc: "Understand technical challenges and product requirements.",
  },
  {
    icon: Wrench,
    title: "Improve",
    desc: "Improve designs and redesign for better manufacturability.",
  },
  {
    icon: Layers,
    title: "Choose",
    desc: "Select the right materials, technology and manufacturing process.",
  },
  {
    icon: Hammer,
    title: "Build",
    desc: "Move forward with confidence toward prototype development.",
  },
];

export default function ExpertNetwork() {
  return (
    <section className="w-full bg-[#faf6ee]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
        {/* Eyebrow */}
        <p className="text-[11px] sm:text-xs tracking-[0.2em] font-semibold text-amber-500 uppercase mb-5">
          The Expert Network
        </p>

        {/* Headline */}
        <h2 className="font-serif text-[#111726] leading-[1.1] text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] max-w-3xl">
          Where innovation meets{" "}
          <span className="text-amber-500">experience.</span>
        </h2>

        {/* Paragraph */}
        <p className="mt-6 sm:mt-7 text-slate-500 text-base sm:text-lg leading-relaxed max-w-3xl">
          Innovators often have great ideas but don&apos;t always know how to
          convert them into technically feasible, manufacturable products.
          The APIC ProtoHub Expert Network connects them with professionals
          with practical industry experience across engineering, product
          design, manufacturing, electronics, automation and other technology
          domains.
        </p>

        {/* Cards */}
        <div className="mt-12 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {steps.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="rounded-2xl border border-black/10 bg-white p-6 sm:p-7 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
            >
              <div className="w-12 h-12 rounded-xl bg-[#0d1526] flex items-center justify-center mb-6">
                <Icon className="w-5 h-5 text-amber-400" strokeWidth={1.75} />
              </div>
              <h3 className="font-serif text-[#111726] text-xl sm:text-2xl mb-2">
                {title}
              </h3>
              <p className="text-slate-500 text-sm sm:text-base leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}